'use client'

import { type SVGProps, useId } from 'react'

import { cn } from '../utils/cn'

const LoaderGradient = ({ className, ...props }: SVGProps<SVGSVGElement>) => {
  const id = useId()

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('animate-loader-spin', className)}
      {...props}
    >
      <g clipPath={`url(#paint0_${id})`}>
        <g transform="matrix(0 -0.0075 0.0075 0 10 10)">
          <foreignObject x="-1166.67" y="-1166.67" width="2333.33" height="2333.33">
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(36, 112, 255, 1) 0deg,rgba(222, 234, 255, 1) 360deg)',
                height: '100%',
                width: '100%',
                opacity: '1'
              }}
            />
          </foreignObject>
        </g>
      </g>
      <path d="M16.875 10C16.875 13.797 13.797 16.875 10 16.875V18.125C14.4873 18.125 18.125 14.4873 18.125 10H16.875ZM10 16.875C6.20304 16.875 3.125 13.797 3.125 10H1.875C1.875 14.4873 5.51269 18.125 10 18.125V16.875ZM3.125 10C3.125 6.20304 6.20304 3.125 10 3.125V1.875C5.51269 1.875 1.875 5.51269 1.875 10H3.125ZM10 3.125C13.797 3.125 16.875 6.20304 16.875 10H18.125C18.125 5.51269 14.4873 1.875 10 1.875V3.125Z" />
      <g clipPath={`url(#paint0_${id})`}>
        <g transform="matrix(0.00125 -0.0075 0.0075 0.00125 10 10)">
          <foreignObject x="-1324.32" y="-1324.32" width="2648.65" height="2648.65">
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(36, 112, 255, 1) 0deg,rgba(222, 234, 255, 1) 360deg)',
                height: '100%',
                width: '100%',
                opacity: '1'
              }}
            />
          </foreignObject>
        </g>
      </g>
      <path d="M18.125 10C18.125 9.65482 17.8452 9.375 17.5 9.375C17.1548 9.375 16.875 9.65482 16.875 10H18.125ZM10 3.125C10.3452 3.125 10.625 2.84518 10.625 2.5C10.625 2.15482 10.3452 1.875 10 1.875V3.125ZM16.875 10C16.875 13.797 13.797 16.875 10 16.875V18.125C14.4873 18.125 18.125 14.4873 18.125 10H16.875ZM10 16.875C6.20304 16.875 3.125 13.797 3.125 10H1.875C1.875 14.4873 5.51269 18.125 10 18.125V16.875ZM3.125 10C3.125 6.20304 6.20304 3.125 10 3.125V1.875C5.51269 1.875 1.875 5.51269 1.875 10H3.125Z" />
      <defs>
        <clipPath id={`paint0_${id}`}>
          <path d="M16.875 10C16.875 13.797 13.797 16.875 10 16.875V18.125C14.4873 18.125 18.125 14.4873 18.125 10H16.875ZM10 16.875C6.20304 16.875 3.125 13.797 3.125 10H1.875C1.875 14.4873 5.51269 18.125 10 18.125V16.875ZM3.125 10C3.125 6.20304 6.20304 3.125 10 3.125V1.875C5.51269 1.875 1.875 5.51269 1.875 10H3.125ZM10 3.125C13.797 3.125 16.875 6.20304 16.875 10H18.125C18.125 5.51269 14.4873 1.875 10 1.875V3.125Z" />
        </clipPath>
        <clipPath id={`paint0_${id}`}>
          <path d="M18.125 10C18.125 9.65482 17.8452 9.375 17.5 9.375C17.1548 9.375 16.875 9.65482 16.875 10H18.125ZM10 3.125C10.3452 3.125 10.625 2.84518 10.625 2.5C10.625 2.15482 10.3452 1.875 10 1.875V3.125ZM16.875 10C16.875 13.797 13.797 16.875 10 16.875V18.125C14.4873 18.125 18.125 14.4873 18.125 10H16.875ZM10 16.875C6.20304 16.875 3.125 13.797 3.125 10H1.875C1.875 14.4873 5.51269 18.125 10 18.125V16.875ZM3.125 10C3.125 6.20304 6.20304 3.125 10 3.125V1.875C5.51269 1.875 1.875 5.51269 1.875 10H3.125Z" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default LoaderGradient
